import React, { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { isGuestOrFreemiumUser } from '../../utils/getUserDetails';

import { FREE_USER_FOOTER_LINKS, GUEST_FOOTER_LINKS } from './FooterLinks';


function MemberFooterLinks(props) {
  const { isAnchor, user, shouldHideAffiliatesLink, isFreemiumUser } = props;
  const isGuestOrFreeUser = isGuestOrFreemiumUser(user);

  const isSfwUser = user?.sfw;

  const getGuestFooterLinks = useCallback(() => {
    if (isSfwUser) {
      return GUEST_FOOTER_LINKS.filter((link) => link.title !== 'Media');
    }

    return GUEST_FOOTER_LINKS;
  }, [isSfwUser]);

  const linksToMap = useMemo(() => {
    if (!user?.authenticated) {
      return getGuestFooterLinks();
    }
    if (isFreemiumUser) {
      return FREE_USER_FOOTER_LINKS;
    }

    return null;
  }, [user?.authenticated, isFreemiumUser, getGuestFooterLinks]);

  const getLink = useCallback((link) => {
    if (link.title === 'Mr.Skin') {
      return <a href={link.url} rel={link.rel || ''} target={link.target}>{link.title}</a>;
    }

    return <Link rel={link.rel || ''} target={link.target} to={link.url}>{link.title}</Link>;
  }, []);

  if (!isGuestOrFreeUser) {
    return (
      <>
        <div className="col-xs-12 text-center">
          <ul className="list-unstyled">
            {!isAnchor && (<li>
              <Link to="/account/purchase">
                Join Naked News
              </Link>
            </li>)}
            <li>
              <Link to="/home">Today&#39;s Show</Link>
            </li>
            <li>
              <Link to="/naked-amateur-auditions">
                Amateur Auditions
              </Link>
            </li>
            <li>
              <Link to="/archives">Archives</Link>
            </li>
            <li>
              <Link to="/media">Media</Link>
            </li>
            <li>
              <Link to="/featured-content">Featured Content</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
            <li>
              <Link to="/contact/complaint">Report Complaint</Link>
            </li>
            {user.authenticated && (
              <li>
                <Link to="/account">My Account</Link>
              </li>
            )}
            {(user.authenticated && !isAnchor) && (
              <li>
                <Link to="/account/subscriptions">
                  Cancel Subscription
                </Link>
              </li>
            )}
            <li>
              <Link to="/faq">F.A.Q.</Link>
            </li>
            <li>
              <Link to="/privacy_policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/cookie-policy">Cookie Policy</Link>
            </li>
            <li>
              <Link to="/cookie-settings">
                Cookie Settings
              </Link>
            </li>
            <li>
              <Link to="/terms_of_service">
                Terms and Conditions
              </Link>
            </li>
            {!shouldHideAffiliatesLink && <li>
              <Link rel="noopener noreferrer" target="_blank" to="/affiliates">
                Affiliates
              </Link>
            </li>}
            <li>
              <Link to="/billing/processing">
                Billing Support
              </Link>
            </li>
            <li>
              <Link to="/2257">18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement</Link>
            </li>
          </ul>
        </div>
      </>
    );
  }

  return (
    <div className="col-xs-12 text-center">
      <ul className="list-unstyled">
        {linksToMap.map((link) => (
          <li key={link.url} className=" ">
            {getLink(link)}
          </li>
        )
        )}
      </ul>
    </div>
  );
}

export default React.memo(MemberFooterLinks);
